import Vue from "vue";
import VueAuthenticate from "vue-authenticate";

Vue.use(VueAuthenticate, {
  tokenPath: "token",
  baseUrl: process.env.VUE_APP_SERVER_ADDRESS + "/api/v1/",
  providers: {
    facebook: {
      authorizationEndpoint: "/api/v1/auth/facebook",
      redirectUri: "/api/v1/auth/retrieve_token",
      responseType: "token",
    },
    twitter: {
      url: "/api/v1/auth/twitter",
      authorizationEndpoint: "/api/v1/auth/twitter",
      redirectUri: "/api/v1/auth/retrieve_token",
      oauthType: "2.0",
      responseType: "token",
    },
    linkedin: {
      authorizationEndpoint: "/api/v1/auth/linkedin",
      redirectUri: "/api/v1/auth/retrieve_token",
      responseType: "token",
    },
  },
});
